import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getTenantRoles = (tenantId) => {
  return axios.request({
    url: workFlowBaseUrl + 'tenant_roles/' + tenantId + '/get/',
    method: 'get'
  })
}

export const modifyTenantRoles = (data, tenantId) => {
  return axios.request({
    url: workFlowBaseUrl + 'tenant_roles/' + tenantId + '/modify/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

// 获取租户用户明细
export const getTenantRolesUser = (tenantId) => {
  return axios.request({
    url: workFlowBaseUrl + 'get_tenant_roles_users/' + tenantId + '/',
    method: 'get'
  })
}
